import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useState} from 'react'
import {NegativeFeedbackButton, PositiveFeedbackButton} from './Buttons'
import {useSubmitGroupsFeedbackMutation} from '../../mutations/use-submit-groups-feedback-mutation'
import {useChangeGroupGeneration} from '../../stores/selectors'

export type FeedbackType = 'POSITIVE' | 'NEGATIVE'

export type FeedbackSubmitHandler = (props: {
  type: FeedbackType
  feedbackChoice?: string[]
  textResponse?: string
}) => void

const Feedback = ({onNegativeFeedbackSubmit}: {onNegativeFeedbackSubmit: () => void}) => {
  const [typeSubmitted, setTypeSubmitted] = useState<FeedbackType>()

  const {mutate: handleSubmit} = useSubmitGroupsFeedbackMutation()

  const feedbackOptions = useChangeGroupGeneration().changeGroupFeedbackOptions

  const handleFeedbackSubmit: FeedbackSubmitHandler = props => {
    setTypeSubmitted(props.type)
    handleSubmit(props)
  }

  const handleNegativeFeedbackSubmit: FeedbackSubmitHandler = props => {
    onNegativeFeedbackSubmit()
    handleFeedbackSubmit(props)
  }

  return (
    <div className="d-flex">
      {typeSubmitted !== 'NEGATIVE' && (
        <PositiveFeedbackButton disabled={!!typeSubmitted} onSubmit={handleFeedbackSubmit} />
      )}
      {typeSubmitted !== 'POSITIVE' && (
        <NegativeFeedbackButton
          disabled={!!typeSubmitted}
          onSubmit={handleNegativeFeedbackSubmit}
          feedbackOptions={feedbackOptions}
        />
      )}
    </div>
  )
}

export const GroupsFeedback = ({
  className,
  onNegativeFeedbackSubmit,
}: {
  className?: string
  onNegativeFeedbackSubmit: () => void
}) => (
  <div className={className}>
    <ErrorBoundary boundaryName="GroupsFeedback" fallback={null}>
      <Feedback onNegativeFeedbackSubmit={onNegativeFeedbackSubmit} />
    </ErrorBoundary>
  </div>
)
